import { Navigate, Route, Routes } from "react-router-dom";
import { FeaturesFlags } from "helpers";
import { useEnvContext } from "contexts";
import { useLinks } from "hooks/useLinks";
import { PrivateRoute } from "./PrivateRoute";
// Pages:
import ClubFreeGift from "pages/ClubFreeGift";
import ClubShop from "pages/ClubShop";
import DailyGift from "pages/DailyGift";
import DripOffer from "pages/DripOffer";
import EliteDeals from "pages/EliteDeals";
import FriendCenter from "pages/FriendCenter";

import FriendShop from "pages/FriendCenter/FriendShop";
import FriendInvite from "pages/FriendCenter/FriendInvite";
import FriendSelection from "pages/FriendCenter/FriendShop/FriendSelection";
import InviteProgress from "pages/FriendCenter/FriendInvite/InviteProgress";
import GiftSelection from "pages/FriendCenter/FriendShop/GiftSelection";
import LandingPage from "pages/LandingPage";
import LoyaltyShop from "pages/LoyaltyShop";
import MerchShop from "pages/MerchShop";
import NewsArticlePage from "pages/News/NewsArticlePage";
import NewsListPage from "pages/News";
import NewsLayout from "pages/News/NewsLayout";
import PageNotFound from "pages/PageNotFound";
import PoisBountyPage from "pages/PoisBountyV3";
import PrivacyAdsToggle from "pages/PrivacyAdsToggle";
import StoreFront from "pages/StoreFront";
import WinnersPage from "pages/Winners";
import StoreFrontV2 from "pages/StoreFront/index_v2";
import { FriendCenterIndex } from "pages/FriendCenter/FriendCenterIndex";
import FriendSelectionReferral from "pages/FriendCenter/FriendInvite/FriendSelection";

export const AppRoutes = () => {
	const { isFeatureFlagEnabled, isFeatureFlagsRefetching } = useEnvContext();
	const {
		shop,
		loyalty,
		privacy_ads_toggle,
		club_shop,
		free_daily_gifts,
		club_free_gift,
		news,
		pois_bounty,
		winners,
		merch_shop,
		drip_offer,
		friend_center,
		elite_deals
	} = useLinks();

	return (
		<Routes>
			<Route index element={<LandingPage />} />
			<Route
				path={shop.path}
				element={
					isFeatureFlagEnabled(FeaturesFlags.UI_V2) ? (
						<StoreFrontV2 />
					) : isFeatureFlagsRefetching ? null : (
						<StoreFront />
					)
				}
			/>
			<Route path={loyalty.path} element={<LoyaltyShop />} />
			{/* Loyalty points: redirect legacy paths */}
			{loyalty.legacyPaths?.map((path) => (
				<Route
					key={path}
					path={path}
					element={<Navigate to={loyalty.path} replace />}
				/>
			))}
			<Route path={privacy_ads_toggle.path} element={<PrivacyAdsToggle />} />
			<Route path={club_shop.path} element={<ClubShop />} />
			<Route path={free_daily_gifts.path} element={<DailyGift />} />
			<Route path={club_free_gift.path} element={<ClubFreeGift />} />
			<Route path={merch_shop.path} element={<MerchShop />} />
			<Route path={news.path} element={<NewsLayout />}>
				<Route index element={<NewsListPage />} />
				<Route path={"page/:num"} element={<NewsListPage />} />
				<Route path={":slug"} element={<NewsArticlePage />} />
			</Route>
			<Route path={winners.path} element={<WinnersPage />} />
			<Route path={pois_bounty.path} element={<PoisBountyPage />} />
			<Route path={drip_offer.path} element={<DripOffer />} />
			<Route
				path={friend_center.path}
				element={
					<PrivateRoute
						isEnabled={isFeatureFlagEnabled(FeaturesFlags.FRIEND_CENTER)}
					>
						<FriendCenter />
					</PrivateRoute>
				}
			>
				<Route index element={<FriendCenterIndex />} />
				<Route
					path="shop"
					element={
						isFeatureFlagEnabled(FeaturesFlags.FRIEND_SHOP) ? (
							<FriendShop />
						) : (
							<Navigate to="/friend-center" replace />
						)
					}
				>
					<Route index element={<Navigate to="gifts" replace />} />
					<Route path="gifts" element={<GiftSelection />} />
					<Route
						path="gifts/:giftIndex/friends"
						element={<FriendSelection />}
					/>
					<Route path="*" element={<Navigate to="gifts" replace />} />
				</Route>
				<Route
					path="invite"
					element={
						isFeatureFlagEnabled(FeaturesFlags.FRIEND_REFERRAL) ? (
							<FriendInvite />
						) : (
							<Navigate to="/friend-center" replace />
						)
					}
				>
					<Route index element={<Navigate to="progress" replace />} />
					<Route path="progress" element={<InviteProgress />} />
					<Route
						path="progress/friends"
						element={<FriendSelectionReferral />}
					/>
					<Route path="*" element={<Navigate to="progress" replace />} />
				</Route>
			</Route>
			<Route path={elite_deals.path} element={<EliteDeals />} />
			<Route path="*" element={<PageNotFound />} />
		</Routes>
	);
};
